import FieldSet from '../../FieldSet';

import { PrioritizedBacklogRank } from './PrioritizedBacklogRank';

export class PrioritizedBacklogRankFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [PrioritizedBacklogRank];
  }

  get title() {
    return 'Prioritized backlog rank';
  }
}
